import { ExperienceList } from '@/components/about/ExperienceList'
import { PageHeader } from '@/components/layout/PageHeader'
import { experience } from '@/content/experience'
import { site } from '@/content/site'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import pageStyles from './Page.module.css'
import styles from './AboutPage.module.css'

export function AboutPage() {
  useDocumentTitle('About')

  return (
    <div className={pageStyles.page}>
      <PageHeader eyebrow="About" title="A bit about me." />

      <section className={styles.intro}>
        <img
          className={styles.portrait}
          src="/assets/000077760018.jpg"
          alt="Alex Trinh"
          loading="lazy"
        />
        <div className={styles.introText}>
          <p className={styles.lede}>Hello, I&rsquo;m Alex.</p>
          <p>{site.intro}</p>
          <p>
            If you&rsquo;d like to know more, the contact page has the fastest ways to
            reach me.
          </p>
        </div>
      </section>

      <section className={pageStyles.section}>
        <h2 className={pageStyles.sectionTitle}>Experience</h2>
        <ExperienceList entries={experience} />
      </section>
    </div>
  )
}
